<template>
  <div class="waveform-select-input">
    <div class="edit" v-if="!readOnly" >
      <multi-select-component
        mode="single"
        v-model="internalValue"
        :options="valueOptionsWaveform"
        :configurationOptions="{'allow-empty': false, 'label-inside':false}"
        >
        <template v-slot:customOption="{props}" >
          <div class="plot-and-name-container">
            <div class="mini-ecg-container">
              <MiniEcg :data="props.option.value.rows" theme="blue"></MiniEcg>
            </div>
            <div class="name">{{props.option.value.name}}</div>
          </div>
        </template>
        <template v-slot:customSingleLabel="{props}" >
          <div class="plot-and-name-container">
            <div class="mini-ecg-container">
              <MiniEcg
                v-if="props.option.value.rows"
                :data="props.option.value.rows"
                :key="props.option.value.id"
                theme="blue"
              ></MiniEcg>
            </div>
            <span class="name">{{props.option.value.name}}</span>
          </div>
        </template>
        <template slot="customAfterList">
          <div class="after-list-container">
            <label :for="`inputFile_${uuid}`" class="upload btn btn--primary">
              {{customOption?'Upload a different file':'Upload a file'}}
            </label>
            <input class="hidden-input" type="file" :id="`inputFile_${uuid}`" accept=".csv" @change="createNewOption">
            <a class="download" :href="exampleUrl" download="example.csv">
              <div class="download-text"> Download sample file (csv)</div>
            </a>
          </div>
        </template>
      </multi-select-component >
    </div>
    <div class="read" v-else>
      <div class="plot-and-name-container" v-if="internalValue">
        <div class="mini-ecg-container">
          <MiniEcg
            v-if="internalValue.rows"
            :data="internalValue.rows"
            :key="internalValue.id"
            theme="blue"
          ></MiniEcg>
        </div>
        <span class="name">{{internalValue.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import MiniEcg from '@/components/CaseDashboard/MiniEcg'
import Papa from 'papaparse'
import { v4 as uuid } from 'uuid';

export default {
  name: 'WaveformSelectInput',
  mixins: [inputMixin],
  components: {MiniEcg, MultiSelectComponent},
  data () {
    return {
      exampleUrl: "data:text/plain;charset=utf-8," + encodeURIComponent('0,0\n1,1'),
      customOption: null,
      uuid: uuid()
    }
  },
  computed: {
    valueOptionsWaveform () {
      if(this.internalValue && !this.valueOptions.find((vo)=>vo.id===this.internalValue.id)){
        this.customOption = this.internalValue
      }
      if (this.customOption) {
        return this.valueOptions.concat(this.customOption)
      }
      return this.valueOptions
    }
  },
  methods: {
    createNewOption (e) {
      let self = this

      var file = e.target.files[0];
      if (!file) {
        return;
      }
      var reader = new FileReader();

      reader.onload = function(e) {
        let contents = e.target.result
        let rows = Papa.parse(contents, { header: false, dynamicTyping: true, skipEmptyLines: true }).data
        if (Array.isArray(rows) && rows[0].length === 2) {// podria ser un mejor check
          self.customOption = {
            name: 'Custom Option',
            headers: ['x','y'],
            rows: rows,
            id: -1,
            units: ["", ""]
          }
          self.internalValue = self.customOption
        } else {
          alert( 'File has not the correct format')
        }
      }

      reader.readAsText(file)
    }
  }
}
</script>

<style lang="stylus" scoped>
.waveform-select-input
  max-width: 350px
  // width: 300px
  .edit
    .multi-select-component
      min-width: 200px
      .multiselect
        .multiselect__content-wrapper
          overflow: hidden
          .multiselect__content
            overflow-x: hidden
            .after-list-container
              // height: 100px
              justify-content: center
              align-items: center
              display: flex
              flex-direction: column
              padding-top: 10px
              border-top: 1px solid #999999
              .hidden-input
                display: none;
              .upload
                margin-bottom: 10px
                max-width: 150px
              .uploaded
                margin 5px
              .download
                color $trout
                m-font-size(12,15)

.plot-and-name-container
  align-items: center
  display: flex
  // width: 100%
  .mini-ecg-container
    flex: 1 0 100px
    height: 25px
    position relative
    // .mini-ecg
    //   position absolute
    //   width 100%
    //   height 100%
  .name
    flex: 0 0 180px
    padding-left: 10px
    m-ellipsis(100%)


</style>